import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AuthenticationService, UserService} from "../../../core/service";
import {TranslatePipe} from "@ngx-translate/core";
import {emailRegex} from "../../../core/helpers/constants";
import {Patch} from "../../../core/models/patch";
import {ConsentDTO, ConsentTypeEnum} from "../../../core/models/consent";
import {ConsentService} from "../../../core/service/consent.service";

@Component({
  selector: 'app-show-consent',
  templateUrl: './show-consent.component.html',
  styleUrls: ['./show-consent.component.scss'],
  providers: [TranslatePipe]
})
export class ShowConsentComponent implements OnInit {

  @Input() userId: string;
  @Input() accessToken: string;
  @Input() userEmail: string;

  email = '';
  emailError = false;

  missingConsents: ConsentDTO[] = [];
  consentChecked: { [consentId: number]: boolean } = {};
  loading = true;

  readonly ConsentTypeEnum = ConsentTypeEnum;

  constructor(public activeModal: NgbActiveModal,
              public authenticationService: AuthenticationService,
              private userService: UserService,
              private consentService: ConsentService) {
  }

  ngOnInit(): void {
    this.consentService.getMissingConsents(this.userId, this.accessToken).subscribe({
      next: (consents) => {
        this.missingConsents = consents;
        consents.forEach(c => this.consentChecked[c.id] = false);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  shouldEmailBeChanged() {
    return this.userEmail.includes("fake.mybenefits.ro");
  }

  get allConsentsChecked(): boolean {
    return this.missingConsents.every(c => this.consentChecked[c.id]);
  }

  getConsentLabel(consentType: ConsentTypeEnum): string {
    switch (consentType) {
      case ConsentTypeEnum.GDPR:
        return 'FOOTER.GDPR';
      case ConsentTypeEnum.MyBenefitsTerms:
        return 'REGISTER.MYBENEFITS_TERMS';
      case ConsentTypeEnum.PrivacyPolicy:
        return 'REGISTER.PRIVACY_POLICY';
      default:
        return '';
    }
  }

  getConsentAgreementLabel(consentType: ConsentTypeEnum): string {
    if (consentType === ConsentTypeEnum.GDPR) {
      return 'REGISTER.AGREE_GDPR';
    }
    return 'REGISTER.AGREE';
  }

  public closeBtnClick(consent: boolean) {
    if (consent) {
      if (this.shouldEmailBeChanged()) {
        if (!emailRegex.test(this.email)) {
          this.emailError = true;
          return;
        }
        this.emailError = false;
      }

      const consentIds = this.missingConsents.map(c => c.id);
      this.consentService.recordConsent(this.userId, this.accessToken, consentIds).subscribe({
        next: () => {
          if (this.shouldEmailBeChanged()) {
            this.changeEmail();
          } else {
            this.activeModal.close({res: true, email: this.email});
          }
        },
        error: () => {
          this.activeModal.close({res: false, email: this.email});
        }
      });
    } else {
      this.activeModal.close({res: false, email: this.email});
    }
  }

  changeEmail() {
    const patchData: Array<Patch> = [{
      op: 'replace',
      path: 'email',
      value: this.email,
    }];

    this.userService
      .editUser(patchData, this.userId, this.accessToken)
      .subscribe({
        next: () => this.activeModal.close({res: true, email: this.email}),
        error: () => this.activeModal.close({res: false, email: this.email})
      });
  }

  openNewTab(url: string) {
    window.open(url);
  }
}
